// src/utils/UtcMinusFour.js

import { format } from "date-fns";

class UtcMinusFour {
  constructor(date = new Date()) {
    this.date = new Date(date);
    this.utcMinusFourOffset = -4 * 60;
  }

  getUtcMinusFourTime() {
    const utcDate = new Date(
      this.date.getTime() + this.date.getTimezoneOffset() * 60000
    );
    utcDate.setMinutes(utcDate.getMinutes() + this.utcMinusFourOffset);
    return utcDate;
  }

  formatUtcMinusFour(formatStr = "yyyy-MM-dd hh:mm a") {
    const utcMinusFourDate = this.getUtcMinusFourTime();
    return format(utcMinusFourDate, formatStr);
  }
}

export default UtcMinusFour;
